import { useState, useEffect } from 'react'
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material'

import Dialog from './Dialog'
import DatePicker from './DatePicker'
import InputField from './InputField'
import GridIconButton from './GridIconButton'
import SortableTableHead from './SortableTableHead'
import { titlesImpostazioni } from '../settings/settings'
import {
  fromDateToString,
  fromStringToDate,
  formatBodyField,
} from '../hooks/utils-functions'
import {
  useGetDomenicheQuery,
  useCreateDomenicaMutation,
  useUpdateDomenicaMutation,
  useDeleteDomenicaMutation,
} from '../hooks/api-slice'

const columnsDomeniche = [
  { label: 'Giornata', sortable: false },
  { label: 'Domenica', sortable: false },
  { label: 'Settimana di gara', sortable: false },
  { label: 'Opzioni', sortable: false },
]

const DialogDomeniche = ({ open, handleClose }) => {
  const { data: domeniche } = useGetDomenicheQuery()

  const [createDomenicaMutation] = useCreateDomenicaMutation()
  const [updateDomenicaMutation] = useUpdateDomenicaMutation()
  const [deleteDomenicaMutation] = useDeleteDomenicaMutation()

  const [editingDomenica, setEditingDomenica] = useState()
  const [addingDomenica, setAddingDomenica] = useState()
  const [newDomenica, setNewDomenica] = useState()

  const cSetNewDomenica = (field, value) =>
    setNewDomenica({ ...newDomenica, [field]: formatBodyField(value) })

  const weekWindow = domenica => {
    if (!fromStringToDate(domenica)) return ''

    const domDate = fromStringToDate(domenica).getDate()
    const domShift = n =>
      fromDateToString(
        new Date(fromStringToDate(domenica).setDate(domDate + n)),
      )
    return `dal ${domShift(-2)} al ${domShift(4)}`
  }

  const clearNewDomenica = () => {
    setEditingDomenica()
    setAddingDomenica()
    setNewDomenica()
  }

  useEffect(() => {
    clearNewDomenica()
  }, [open])

  const addNewDomenica = async () => {
    const result = await createDomenicaMutation(newDomenica)
    if (!result.error) clearNewDomenica()
  }

  const editDomenica = async id => {
    const result = await updateDomenicaMutation({ id, ...newDomenica })
    if (!result.error) clearNewDomenica()
  }

  const deleteDomenica = async id => {
    await deleteDomenicaMutation(id)
  }

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      title={titlesImpostazioni.titleDomeniche}
      maxWidth='lg'
      stretchHeight
    >
      {!domeniche ? (
        <h4>Giornate non trovate.</h4>
      ) : (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          <Grid size={12}>
            Le giornate servono all'algoritmo che genera la tabella Iscrizioni
            per tradurre le date di indisponibilità della palestra in giornate
            di gara e servono all'algoritmo Calendari per generare le singole
            partite.
            <br />
            <br />
            Per ogni giornata di gara indicare la data in cui cade la domenica:
            verrà considerata come settimana di gara quella che va dal venerdì
            precedente al giovedì successivo.
          </Grid>
          <Grid container alignItems='center' sx={{ width: '100%' }}>
            {(!!addingDomenica && (
              <>
                <Grid size={{ xs: 4, md: 2 }}>
                  <center>
                    <InputField
                      id='giornata'
                      value={newDomenica?.giornata}
                      onChange={i => cSetNewDomenica('giornata', i)}
                      autoFocus
                      label={columnsDomeniche[0].label}
                      type='number'
                    />
                  </center>
                </Grid>
                <Grid size={{ xs: 8, md: 4 }}>
                  <center>
                    <DatePicker
                      value={newDomenica?.domenica}
                      onChange={i => cSetNewDomenica('domenica', i)}
                      label={columnsDomeniche[1].label}
                    />
                  </center>
                </Grid>
                <Grid size={{ xs: 8, md: 4 }}>
                  <center>{weekWindow(newDomenica?.domenica)}</center>
                </Grid>
                <GridIconButton
                  type='save'
                  size={{ xs: 2, md: 1 }}
                  onClick={addNewDomenica}
                />
                <GridIconButton
                  type='clear'
                  size={{ xs: 2, md: 1 }}
                  onClick={clearNewDomenica}
                />
              </>
            )) || (
              <GridIconButton
                type='add'
                size={12}
                onClick={() => {
                  setEditingDomenica()
                  setAddingDomenica(true)
                  setNewDomenica({})
                }}
                text='Nuova giornata'
              />
            )}
          </Grid>
          {(domeniche.length === 0 && <h4>Nessuna giornata trovata.</h4>) || (
            <TableContainer component={Paper}>
              <Table size='small'>
                <SortableTableHead
                  table={domeniche}
                  columns={columnsDomeniche}
                />
                <TableBody>
                  {domeniche.map((g, index) => {
                    return (
                      <TableRow key={index}>
                        {(editingDomenica === g._id && (
                          <>
                            <TableCell padding='checkbox'>
                              <InputField
                                id='giornata'
                                value={newDomenica?.giornata}
                                onChange={i => cSetNewDomenica('giornata', i)}
                                autoFocus
                                label={columnsDomeniche[0].label}
                                type='number'
                              />
                            </TableCell>
                            <TableCell padding='checkbox'>
                              <DatePicker
                                value={newDomenica?.domenica}
                                onChange={i => cSetNewDomenica('domenica', i)}
                                label={columnsDomeniche[1].label}
                              />
                            </TableCell>
                            <TableCell padding='checkbox'>
                              {weekWindow(newDomenica?.domenica)}
                            </TableCell>
                            <TableCell padding='checkbox'>
                              <Grid container sx={{ width: '100%' }}>
                                <GridIconButton
                                  type='save'
                                  onClick={() => editDomenica(g.id)}
                                />
                                <GridIconButton
                                  type='clear'
                                  onClick={clearNewDomenica}
                                />
                              </Grid>
                            </TableCell>
                          </>
                        )) || (
                          <>
                            <TableCell>{g.giornata}</TableCell>
                            <TableCell>{g.domenica}</TableCell>
                            <TableCell>{weekWindow(g.domenica)}</TableCell>
                            <TableCell>
                              <Grid container sx={{ width: '100%' }}>
                                <GridIconButton
                                  type='edit'
                                  onClick={() => {
                                    setEditingDomenica(g._id)
                                    setAddingDomenica()
                                    setNewDomenica(g)
                                  }}
                                />
                                <GridIconButton
                                  type='delete'
                                  onClick={() => deleteDomenica(g.id)}
                                />
                              </Grid>
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogDomeniche
